<div
  class="d-flex justify-content-center {{ padding }} {{
    fullscreen ? 'loader' : ''
  }}">
  <div class="spinner-grow" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>
